import {Pipe, PipeTransform} from '@angular/core';

export const amenityIconMap: Record<number, string> = {
  66: 'elevator',
  67: 'accessible',                    // Accessible entrance
  8: 'local_parking',                 // Assigned parking spaces
  45: 'child_care',                    // Babysitting / after‑school
  9: 'directions_bike',               // Bike storage
  13: 'directions_bus',                // Bus stop
  47: 'business_center',               // Business center
  30: 'tv',                            // Cable / satellite TV
  26: 'usb',                           // USB charging outlets
  48: 'child_friendly',                // Children’s playroom
  44: 'school',                        // Close to schools
  28: 'wifi',                          // Common‑area Wi‑Fi
  37: 'groups',                        // Community center
  40: 'event',                         // Community events / classes
  61: 'room_service',                  // Concierge
  7: 'garage',                        // Covered parking
  17: 'dishwasher',                    // Dishwasher in unit
  2: 'pets',                          // Dog park
  3: 'shower',                        // Dog wash station
  55: 'doorbell',                      // Doorman
  59: 'recycling',                     // Doorstep recycling
  11: 'ev_station',                    // EV charging
  20: 'eco',                           // Energy‑efficient appliances
  22: 'fireplace',                     // Fireplace
  6: 'garage',                        // Garages
  56: 'gate',                          // Gated access
  62: 'park',                          // Green space
  32: 'fitness_center',               // Gymnasium
  24: 'texture',                       // Hardwood floors
  19: 'countertops',                   // High‑end countertops
  18: 'kitchen',                       // High‑end kitchen appliances
  29: 'wifi',                          // High‑speed internet
  65: 'doorbell',                      // Intercommunication device
  42: 'directions_run',                // Jogging / walking path
  4: 'pets',                          // Large dogs allowed
  16: 'local_laundry_service',         // Laundry service
  38: 'theaters',                      // Media room
  5: 'pets',                          // Multiple pets allowed
  60: 'manage_accounts',               // On‑site resident manager
  31: 'payments',                      // Online leasing / rent
  41: 'nature_people',                 // Outdoor areas
  50: 'deck',                          // Outdoor terrace
  63: 'inventory_2',                   // Package lockers
  39: 'celebration',                   // Party room
  23: 'balcony',                       // Patio or balcony
  12: 'directions_walk',               // Pedestrian friendly
  1: 'pets',                          // Pet‑friendly
  43: 'sports_soccer',                 // Playground
  36: 'sports_soccer',                 // Playground (duplicate amenity)
  35: 'pool',                          // Pool
  46: 'sports_esports',                // Recreation room
  58: 'recycling',                     // Recycling center
  51: 'roofing',                       // Rooftop terrace
  53: 'camera_outdoor',                // Security cameras
  54: 'security',                      // Security guard
  49: 'elderly',                       // Senior center
  10: 'directions_car',                // Shared car services
  14: 'local_laundry_service',         // Shared laundry room
  27: 'thermostat',                    // Smart HVAC controls
  68: 'smoke_free',                    // Smoke‑free
  69: 'smoking_rooms',                 // Smoking permitted
  33: 'spa',                           // Spa
  52: 'inventory',                     // Storage
  57: 'delete',                        // Valet trash
  64: 'support_agent',                 // Virtual doorman
  15: 'local_laundry_service',         // Washer / dryer in unit
  34: 'self_improvement',              // Yoga / dance studio
  21: 'ac_unit'                        // Air‑conditioning
};

export const getAmenityIcon = (amenityId: number): string | undefined => {
  return amenityIconMap[amenityId];
}

@Pipe({
  name: 'amenityIcon',
  standalone: true
})
export class AmenityIconPipe implements PipeTransform {

  transform(amenityId: number): string {
    return getAmenityIcon(amenityId) ?? 'check_circle';
  }

}
